import { Component, OnInit } from '@angular/core';
import { FileUploaderComponent } from '../../../../shared/Components/file-uploader/file-uploader.component';
import { BlogsService } from '../../services/blogs-service';
import { Blogs } from '../../models/blogs';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { FileVm } from '../../../../shared/Models/fileVm';
import * as momentHijri from 'moment-hijri';
import { Router } from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { uploadService } from '../../../../shared/uploadService';

@Component({
  selector: 'app-add-blog',
  templateUrl: './add-blog.component.html',
  styleUrls: ['./add-blog.component.scss'],
})
export class AddBlogComponent implements OnInit {
  model: Blogs = {} as Blogs;
  formData: FormData = new FormData();
  validPhoto = false;
  isEdit = false;
  uploadThumbnail = false;
  ImagePath: string = '';
  isLoading: boolean;
  constructor(
    private service: BlogsService,
    private diagRef: NbDialogRef<AddBlogComponent>,
    private toast: NbToastrService,
    private route: Router,
    private uploadservice: uploadService
  ) {}

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });
    if (!this.isEdit) {
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.uploadThumbnail = true;
      this.model.attachments = [];
      this.uploadservice.updateFiles({ files: [], previousAttachments: [] });
    } else {
      this.validPhoto = true;
      this.uploadservice.updateFiles({ files: [], previousAttachments: this.model.attachments });
    }
  }
  //  AddImages(img)
  //  {
  //     var count =Math.ceil(img.length/5)
  //     console.log("count ="+count)
  //     for(var i =0;i<count ; i++)
  //     {
  //       console.log("enter to loop")
  //        this.model.attachmentsRequest[0].images[i] = img
  //     }
  //  }

  save() {
    this.isLoading = true;
    if (!this.model.dateTime) {
      this.model.dateTime = momentHijri(new Date());
    }
    this.service.uploadFile(this.formData).subscribe((res) => {
      this.model.thumbnail = {} as FileVm;
      this.model.thumbnail.fileName = res.fileName;

      const attachments$ = this.uploadservice.uploadMultipleFiles();
      combineLatest([attachments$])
        .pipe(
          catchError(() => {
            console.log('error here in combine latest ');
            return of(null);
          }),

          switchMap(([img]) => {
            this.model.attachments = img;
            return this.saveEntity(this.model);
          }),
          tap(() => {})
        )
        .subscribe(
          (res) => {
            this.isLoading = false;
            this.diagRef.close('true');
            this.toast.success('تمت الاضافة  بنجاح', '', { status: 'success', duration: 3000 });
          }
        );
    });
  }

  saveEntity(model): Observable<any> {
    return this.service.post(model);
  }

  getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }

  close() {
    this.diagRef.close();
  }

  removePhoot() {
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }

  updateBlogs() {
    this.isLoading = true;
    let hasNewFile = false;
    this.formData.forEach((_) => {
      hasNewFile = true;
    });

    if (hasNewFile) {
      this.service.uploadFile(this.formData).subscribe((res) => {
        this.model.thumbnail.fileName = res.fileName;
        this.formData.forEach((file) => {
          this.model.thumbnail.originalFileName = file.valueOf()['name'];
        });

        this.update();
      });
    } else {
      this.update();
    }
  }

  update() {
    const attachments$ = this.uploadservice.uploadMultipleFiles();
    combineLatest([attachments$])
      .pipe(
        catchError(() => {
          console.log('error here in combine latest ');
          return of(null);
        }),
        switchMap(([img]) => {
          this.model.attachments = img;
          return this.service.put(this.model.id, this.model);
        }),
        tap(() => {})
      )
      .subscribe(
        (res) => {
          this.isLoading = false;

          this.diagRef.close('true');
          this.toast.show('تم تعديل الوسائط بنجاح', '', { status: 'success', duration: 3000 });
        },
        () => {
          this.isLoading = false;

          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل الوسائط', '', { duration: 3000 });
        }
      );
  }

  setDate(event) {
    this.model.dateTime = event;
  }
}
